import { TableColumn } from 'react-data-table-component';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import VisitLinkCell from './Cells/VisitDocLinkCell';

import { VisitReportsData } from 'api/visitReports/type';
import { Breakpoints } from 'hooks/Screen/useScreenSize';

export const useGetVisitReportListTableColumns = (slug: string): TableColumn<VisitReportsData>[] => {
  const { t } = useTranslation();

  return [
    {
      name: t('VisitReportsList.tableTitles.createData'),
      selector: row => (row?.call_date ? dayjs(row.call_date).format('YYYY-MM-DD\xa0\xa0\xa0HH:mm') : '-'),
    },
    {
      name: t('VisitReportsList.tableTitles.startDate'),
      selector: row => row.start_date,
      hide: Breakpoints.Tablet,
    },
    {
      name: t('VisitReportsList.tableTitles.endDate'),
      selector: row => row.end_date,
      hide: Breakpoints.Mobile,
    },
    {
      name: t('VisitReportsList.tableTitles.siteContact'),
      selector: row => row.site_contact || '-',
      hide: Breakpoints.Tablet,
    },
    {
      name: t('VisitReportsList.tableTitles.document'),
      selector: row => row.id,
      cell: row =>
        !row.is_created ? (
          <button className="btn btn-ghost-warning" disabled>
            <i className="ri-loader-2-line ri-spin" /> {t('VisitReportsList.tableTitles.loading')}
          </button>
        ) : (
          <VisitLinkCell link={`/visit-report/${slug}/${row.id}/`} icon="ri-treasure-map-line" />
        ),
    },
    {
      name: t('VisitReportsList.tableTitles.signsture'),
      selector: row => row.id,
      cell: row =>
        !row.is_created ? (
          <button className="btn btn-ghost-warning" disabled>
            <i className="ri-loader-2-line ri-spin" /> Loading...
          </button>
        ) : (
          <VisitLinkCell link={`/visit-report/${slug}/${row.id}/`} icon="ri-treasure-map-line" />
        ),
    },
    {
      name: t('VisitReportsList.tableTitles.createdBy'),
      selector: row => row.created_by,
      hide: Breakpoints.Desktop,
    },
  ];
};
